<tm-header
    class="motors-theme"
    [tradeMeUrl]="tradeMeUrl"
    [myTradeMeUrl]="myTradeMeUrl"
    [myPhotoUrl]="myPhotoUrl"
></tm-header>
